import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chair",
  "use": "chair-usage",
  "viewBox": "0 0 33.6 20.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.6 20.8\" id=\"chair\"><path d=\"M33.5 6.3L16.4 0 0 6.5l7 2.7v8l9.7 3.7 9.8-3.7V8.9l6-2.2V19h1.1V6.3h-.1zm-8.2 10.1l-8.6 3.2-8.5-3.2V9.6l8.1 3.1 9-3.3v7zm-9-4.9l-13.2-5 13.3-5.3 13.9 5.1-14 5.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol